const addonVariantId = 59132803285317;
const managedAddonRoles = new Set(['extra-motiv', 'presentask', 'metallhallare']);

const configuration = (item) => item.properties?.['_WW-konfiguration'];
const role = (item) => item.properties?.['_WW-roll'];

async function reconcileWWCart() {
  if (window.__wwCartReconciling) return;
  window.__wwCartReconciling = true;
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    const mainQuantities = new Map(
      cart.items
        .filter((item) => role(item) === 'huvudprodukt' && configuration(item))
        .map((item) => [configuration(item), item.quantity])
    );
    const updates = {};
    cart.items.forEach((item) => {
      if (!managedAddonRoles.has(role(item))) return;
      const mainQuantity = mainQuantities.get(configuration(item));
      if (!mainQuantity) {
        updates[item.key] = 0;
      } else if (item.quantity !== mainQuantity) {
        updates[item.key] = mainQuantity;
      }
    });
    if (!Object.keys(updates).length) return;
    const update = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (update.ok) window.location.reload();
  } finally {
    window.__wwCartReconciling = false;
  }
}

reconcileWWCart();
document.addEventListener('cart:update', reconcileWWCart);
document.addEventListener('click', (event) => {
  if (!event.target.closest('cart-items, cart-drawer, form[action*="/cart"]')) return;
  window.setTimeout(reconcileWWCart, 1800);
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('input[name="updates[]"], input[name^="updates["]')) return;
  window.setTimeout(reconcileWWCart, 1800);
});

function hideTechnicalProperties() {
  document.querySelectorAll('.ww-line-props').forEach((list) => { list.hidden = true; });
}

hideTechnicalProperties();
new MutationObserver(hideTechnicalProperties).observe(document.documentElement, { childList: true, subtree: true });
